export const getTournamentAndResults = {
  person: {
    id: '614c4017f60ae6bf2379793a',
    allTournaments: {
      items: [
        {
          id: '615c52903571e133e4653db9090',
          name: 'CIF/Southern/Section/Individual/ChampionshipsCIF/Southern-Section/Individual/Championships',
          start: '2021-06-09T00:00:00.000Z',
          end: '2021-06-10T00:00:00.000Z',
          providerTournamentId: '7ty7r290-237rghfh802347-1',
          provider: {
            id: '123456TTF',
            providerId: 'ttf123456789',
            name: 'Test Tennis Federation',
            orgId: 'TEST001',
            logoUrl: 'test.com/logo.png',
            displayName: 'TEST',
            landingPageUrl: 'test.com',
            supportPageUrl: 'test.com/support',
            __typename: 'Provider',
          },
          matchUps: {
            items: [
              {
                tournament: {
                  id: '615c52903571e133e4653db7',
                  name: 'CIF Southern Section Individual Championships',
                  start: '2021-06-09T00:00:00.000Z',
                  end: '2021-06-10T00:00:00.000Z',
                  __typename: 'Tournament',
                },
                id: '615c5d343571e133e46cd25a1',
                start: '2021-06-30T00:00:00.000Z',
                end: '2021-06-30T00:00:00.000Z',
                worldTennisNumbers: [
                  {
                    type: 'DOUBLE',
                    confidence: 0.7,
                    tennisNumber: 31.15,
                    personId: '614c4017f60ae6bf2379793a',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'DOUBLE',
                    confidence: 0.4,
                    tennisNumber: 31.15,
                    personId: '60a4ed93bf0fe5a6987a1085',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'DOUBLE',
                    confidence: 0.8,
                    tennisNumber: 23.09,
                    personId: '60a4ed2fbf0fe5a69877edf9',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'DOUBLE',
                    confidence: 0.4,
                    tennisNumber: 22.03,
                    personId: '60a4ed0cbf0fe5a698772742',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                ],
                winningSide: 'SIDE1',
                score: {
                  superTiebreak: null,
                  sets: [
                    {
                      winnerGamesWon: 6,
                      loserGamesWon: 2,
                      tiebreaker: null,
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: 7,
                      loserGamesWon: 6,
                      tiebreaker: {
                        winnerPointsWon: 10,
                        loserPointsWon: 6,
                        __typename: 'Tiebreaker',
                      },
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: 2,
                      loserGamesWon: 6,
                      tiebreaker: null,
                      __typename: 'Set',
                    },
                  ],
                  __typename: 'Score',
                },
                status: 'COMPLETED',
                sides: [
                  {
                    players: [
                      {
                        person: {
                          id: '60a4ed2fbf0fe5a69877edf9',
                          nativeGivenName: 'Christopher',
                          nativeFamilyName: 'Koeberle',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                      {
                        person: {
                          id: '60a4ed0cbf0fe5a698772742',
                          nativeGivenName: 'Kyle',
                          nativeFamilyName: 'Shigekawa',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE1',
                    __typename: 'Side',
                  },
                  {
                    players: [
                      {
                        person: {
                          id: '60a4ed93bf0fe5a6987a1085',
                          nativeGivenName: 'Keaton',
                          nativeFamilyName: 'Cross',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                      {
                        person: {
                          id: '614c4017f60ae6bf2379793a',
                          nativeGivenName: 'UNKNOWN',
                          nativeFamilyName: 'UNKNOWN',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: true,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE2',
                    __typename: 'Side',
                  },
                ],
                type: 'DOUBLES',
                __typename: 'MatchUp',
              },
              {
                tournament: {
                  id: '615c52903571e133e4653db7',
                  name: 'CIF Southern Section Individual Championships',
                  start: '2021-06-09T00:00:00.000Z',
                  end: '2021-06-10T00:00:00.000Z',
                  __typename: 'Tournament',
                },
                id: '615c5d343571e133e46cd25a',
                start: '2021-06-30T00:00:00.000Z',
                end: '2021-06-30T00:00:00.000Z',
                worldTennisNumbers: [
                  {
                    type: 'DOUBLE',
                    confidence: 0.7,
                    tennisNumber: 31.15,
                    personId: '614c4017f60ae6bf2379793a',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'DOUBLE',
                    confidence: 0.4,
                    tennisNumber: 31.15,
                    personId: '60a4ed93bf0fe5a6987a1085',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'DOUBLE',
                    confidence: 0.8,
                    tennisNumber: 23.09,
                    personId: '60a4ed2fbf0fe5a69877edf9',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'DOUBLE',
                    confidence: 0.4,
                    tennisNumber: 22.03,
                    personId: '60a4ed0cbf0fe5a698772742',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                ],
                winningSide: 'SIDE1',
                score: {
                  superTiebreak: null,
                  sets: [
                    {
                      winnerGamesWon: 6,
                      loserGamesWon: 2,
                      tiebreaker: null,
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: 7,
                      loserGamesWon: 6,
                      tiebreaker: {
                        winnerPointsWon: 10,
                        loserPointsWon: 6,
                        __typename: 'Tiebreaker',
                      },
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: 2,
                      loserGamesWon: 6,
                      tiebreaker: null,
                      __typename: 'Set',
                    },
                  ],
                  __typename: 'Score',
                },
                status: 'BYE',
                sides: [
                  // {
                  //   players: [
                  //     {
                  //       person: {
                  //         id: '60a4ed2fbf0fe5a69877edf9',
                  //         nativeGivenName: 'Christopher',
                  //         nativeFamilyName: 'Koeberle',
                  //         nationalityCode: 'USA',
                  //         optedOutOfPublicDataConsent: false,
                  //         __typename: 'Person',
                  //       },
                  //       playerNumber: null,
                  //       __typename: 'Player',
                  //     },
                  //     {
                  //       person: {
                  //         id: '60a4ed0cbf0fe5a698772742',
                  //         nativeGivenName: 'Kyle',
                  //         nativeFamilyName: 'Shigekawa',
                  //         nationalityCode: 'USA',
                  //         optedOutOfPublicDataConsent: false,
                  //         __typename: 'Person',
                  //       },
                  //       playerNumber: null,
                  //       __typename: 'Player',
                  //     },
                  //   ],
                  //   sideNumber: 'SIDE1',
                  //   __typename: 'Side',
                  // },
                  {
                    players: [
                      // {
                      //   person: {
                      //     id: '60a4ed93bf0fe5a6987a1085',
                      //     nativeGivenName: 'Keaton',
                      //     nativeFamilyName: 'Cross',
                      //     nationalityCode: 'USA',
                      //     optedOutOfPublicDataConsent: false,
                      //     __typename: 'Person',
                      //   },
                      //   playerNumber: null,
                      //   __typename: 'Player',
                      // },
                      {
                        person: {
                          id: '614c4017f60ae6bf2379793a',
                          nativeGivenName: 'Test',
                          nativeFamilyName: 'Player',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE2',
                    __typename: 'Side',
                  },
                ],
                type: 'SINGLES',
                __typename: 'MatchUp',
              },
            ],
            __typename: 'MatchUpList',
          },
          __typename: 'Tournament',
        },
        {
          id: '615c52903571e133e4653dcc',
          name: 'CIF Los Angeles Section Individual Championships',
          start: '2021-06-07T00:00:00.000Z',
          end: '2021-06-09T00:00:00.000Z',
          providerTournamentId: '7ty7r290-237rghfh802347-2',
          provider: {
            id: '123456TTF',
            providerId: 'ttf123456789',
            name: 'Test Tennis Federation',
            orgId: 'TEST001',
            logoUrl: 'test.com/logo.png',
            displayName: 'TEST',
            landingPageUrl: 'test.com',
            supportPageUrl: 'test.com/support',
            __typename: 'Provider',
          },
          matchUps: {
            items: [
              {
                tournament: {
                  id: '615c52903571e133e4653dcc',
                  name: 'CIF Los Angeles Section Individual Championships',
                  start: '2021-06-07T00:00:00.000Z',
                  end: '2021-06-09T00:00:00.000Z',
                  __typename: 'Tournament',
                },
                id: '615c5d343571e133e46cd6fe',
                start: '2021-07-08T00:00:00.000Z',
                end: '2021-07-08T00:00:00.000Z',
                worldTennisNumbers: [
                  {
                    type: 'SINGLE',
                    confidence: 0.7,
                    tennisNumber: 25.82,
                    personId: '60a4ed4bbf0fe5a6987890a2',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'SINGLE',
                    confidence: 0.7,
                    tennisNumber: 31.71,
                    personId: '614c4017f60ae6bf2379793a',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                ],
                winningSide: 'SIDE2',
                score: {
                  superTiebreak: null,
                  sets: [
                    {
                      winnerGamesWon: null,
                      loserGamesWon: null,
                      tiebreaker: {
                        winnerPointsWon: 10,
                        loserPointsWon: 6,
                        __typename: 'Tiebreaker',
                      },
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: null,
                      loserGamesWon: null,
                      tiebreaker: {
                        winnerPointsWon: 9,
                        loserPointsWon: 10,
                        __typename: 'Tiebreaker',
                      },
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: null,
                      loserGamesWon: null,
                      tiebreaker: {
                        winnerPointsWon: 10,
                        loserPointsWon: 6,
                        __typename: 'Tiebreaker',
                      },
                      __typename: 'Set',
                    },
                  ],
                  __typename: 'Score',
                },
                status: 'COMPLETED',
                sides: [
                  {
                    players: [
                      {
                        person: {
                          id: '614c4017f60ae6bf2379793a',
                          nativeGivenName: 'Test',
                          nativeFamilyName: 'Player',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE1',
                    __typename: 'Side',
                  },
                  {
                    players: [
                      {
                        person: {
                          id: '60a4ed4bbf0fe5a6987890a2',
                          nativeGivenName: 'Rocco',
                          nativeFamilyName: 'Melendez',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE2',
                    __typename: 'Side',
                  },
                ],
                type: 'SINGLES',
                __typename: 'MatchUp',
              },
            ],
            __typename: 'MatchUpList',
          },
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
        {
          id: '615c52903571e133e4653dc000',
          name: 'CIF Los Angeles WOW',
          start: '2021-06-07T00:00:00.000Z',
          end: '2021-06-09T00:00:00.000Z',
          providerTournamentId: '7ty7r290-237rghfh802347-3',
          provider: {
            id: '123456TTF',
            providerId: 'ttf123456789',
            name: 'Test Tennis Federation',
            orgId: 'TEST001',
            logoUrl: 'test.com/logo.png',
            displayName: 'TEST',
            landingPageUrl: 'test.com',
            supportPageUrl: 'test.com/support',
            __typename: 'Provider',
          },
          matchUps: {
            items: [
              {
                tournament: {
                  id: '615c52903571e133e4653dcc',
                  name: 'CIF Los Angeles Section Individual Championships',
                  start: '2021-06-07T00:00:00.000Z',
                  end: '2021-06-09T00:00:00.000Z',
                  __typename: 'Tournament',
                },
                id: '615c5d343571e133e46cd6fe',
                start: '2021-07-08T00:00:00.000Z',
                end: '2021-07-08T00:00:00.000Z',
                worldTennisNumbers: [
                  {
                    type: 'SINGLE',
                    confidence: 0.3,
                    tennisNumber: 25.82,
                    personId: '60a4ed4bbf0fe5a6987890a2',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                  {
                    type: 'SINGLE',
                    confidence: 0.7,
                    tennisNumber: 31.71,
                    personId: '614c4017f60ae6bf2379793a',
                    __typename: 'MatchUpWorldTennisNumber',
                  },
                ],
                winningSide: 'SIDE2',
                score: {
                  superTiebreak: {
                    winnerPointsWon: 10,
                    loserPointsWon: 6,
                    __typename: 'Tiebreaker',
                  },
                  sets: [
                    {
                      winnerGamesWon: 6,
                      loserGamesWon: 0,
                      tiebreaker: null,
                      __typename: 'Set',
                    },
                    {
                      winnerGamesWon: 6,
                      loserGamesWon: 0,
                      tiebreaker: null,
                      __typename: 'Set',
                    },
                  ],
                  __typename: 'Score',
                },
                status: 'COMPLETED',
                sides: [
                  {
                    players: [
                      {
                        person: {
                          id: '614c4017f60ae6bf2379793a',
                          nativeGivenName: 'Test',
                          nativeFamilyName: 'Player',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE1',
                    __typename: 'Side',
                  },
                  {
                    players: [
                      {
                        person: {
                          id: '60a4ed4bbf0fe5a6987890a2',
                          nativeGivenName: 'Rocco',
                          nativeFamilyName: 'Melendez',
                          nationalityCode: 'USA',
                          optedOutOfPublicDataConsent: false,
                          isRanked: true,
                          __typename: 'Person',
                        },
                        playerNumber: null,
                        __typename: 'Player',
                      },
                    ],
                    sideNumber: 'SIDE2',
                    __typename: 'Side',
                  },
                ],
                type: 'SINGLES',
                __typename: 'MatchUp',
              },
            ],
            __typename: 'MatchUpList',
          },
          __typename: 'Tournament',
        },
        {
          id: null,
          name: null,
          start: null,
          end: null,
          matchUps: null,
          __typename: 'Tournament',
        },
      ],
      totalItems: 10,
      __typename: 'TournamentList',
    },
    firstTournaments: {
      items: [
        {
          id: '615c52903571e133e4653dcc',
          name: 'CIF Los Angeles Section Individual Championships',
          start: '2021-06-07T00:00:00.000Z',
          __typename: 'Tournament',
        },
        {
          id: '615c52903571e133e4653db7',
          name: 'CIF Southern Section Individual Championships',
          start: '2021-06-09T00:00:00.000Z',
          __typename: 'Tournament',
        },
      ],
      __typename: 'TournamentList',
    },
    __typename: 'Person',
  },
}

export const getTournamentAndResultsPaginated = {
  person: {
    id: '614c4017f60ae6bf2379793a',
    allTournaments: {
      items: [],
      totalItems: 10,
      __typename: 'TournamentList',
    },
    firstTournaments: {
      items: [
        {
          id: '615c52903571e133e4653dcc',
          name: 'CIF Los Angeles Section Individual Championships',
          start: '2021-06-07T00:00:00.000Z',
          __typename: 'Tournament',
        },
        {
          id: '615c52903571e133e4653db7',
          name: 'CIF Southern Section Individual Championships',
          start: '2021-06-09T00:00:00.000Z',
          __typename: 'Tournament',
        },
      ],
      __typename: 'TournamentList',
    },
    __typename: 'Person',
  },
}
